module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-raido-group",
    class: {
      'is-bordered': _vm.bordered
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-71b338e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/radio/tsRadioGroup.vue
// module id = 842
// module chunks = 39